import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { url,urlOwner,test,assets,api,versiCode,urlACS } from '@/var.js'


Vue.use(VueAxios, axios)

export default {
    isTest() {
        return test;
    },
    assets() {
        return assets;
    },
    versi() {
      return api;
    },
    versiCode() {
      return versiCode;
    },
    call(data,urlx) {
        var header = {'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': "application/json"
        };  

        return axios({
          method: "POST",
          url: url+"/"+urlx,
          headers: header, 
          data: data
        }).then((response) => {
            return response.data;
        })
        .catch(error => {
          var error = error.response;
          if(error.response.data.errors){
            console.log(err.response.data.errors)
          }
          return error;
          //this.error(error);
        });            
    },
    callOwn(data,urlx) {
        var header = {'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': "application/json"
        };  

        return axios({
          method: "POST",
          url: urlOwner+"/"+urlx,
          headers: header, 
          data: data
        }).then((response) => {
            return response.data;
        })
        .catch(error => {
          var error = error.response;
          /*
          if(error.response.data.errors){
            console.log(err.response.data.errors)
          }
          */
          return error;
          //this.error(error);
        });            
    },
    callUrlManual(data,urlx) {
        var header = {'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': "application/json"
        };  

        return axios({
          method: "POST",
          url: urlx,
          headers: header, 
          data: data
        }).then((response) => {
            return response.data;
        })
        .catch(error => {
          var error = error.response;
          /*
          if(error.response.data.errors){
            console.log(err.response.data.errors)
          }
          */
          return error;
          //this.error(error);
        });            
    },
    callAcs(data,urlx) {
      var header = {'X-Requested-With': 'XMLHttpRequest',
                      'Content-Type': "application/json"
      };  

      return axios({
        method: "POST",
        url: urlACS+"/"+urlx,
        headers: header, 
        data: data
      }).then((response) => {
          return response.data;
      })
      .catch(error => {
        var error = error.response;
        if(error.response.data.errors){
          console.log(err.response.data.errors)
        }
        return error;
        //this.error(error);
      });            
    },
    ribu(x) {
      var harga = 0;

      if (x != "") {
        try {
          harga = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        catch(err) {
          //
        }
      }

      return 'Rp. '+harga;
    },
    ribuNoRp(x) {
      var harga = 0;

      if (x != "") {
        try {
          harga = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        catch(err) {
          //
        }
      }

      return harga;
    },
    unpetik(x) {
      var text = 0;

      if (x != "") {
        try {
          text = x.toString().split("[petik]").join("'");
        }
        catch(err) {
          //
        }
      }

      return text;
    },
    tglIndo(date) {      
      var bulan = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
      var tgl = new Date(date);
      var kosongJam;
      if (tgl.getHours()<10) {
          kosongJam = "0";
      } else {
          kosongJam = "";
      }
      var kosongMenit;
      if (tgl.getMinutes()<10) {
          kosongMenit = "0";
      } else {
          kosongMenit = "";
      }
      var realBulan = tgl.getDate()+' '+bulan[parseInt(tgl.getMonth())]+' '+tgl.getFullYear();
      
      
      return realBulan;
    },
    BulanOnly(date) {      
      var bulan = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
      var tgl = new Date(date);
      var kosongJam;
      if (tgl.getHours()<10) {
          kosongJam = "0";
      } else {
          kosongJam = "";
      }
      var kosongMenit;
      if (tgl.getMinutes()<10) {
          kosongMenit = "0";
      } else {
          kosongMenit = "";
      }
      var realBulan = bulan[parseInt(tgl.getMonth())]+' '+tgl.getFullYear();
      
      
      return realBulan;
    },
    BulanSOnly(date) {      
      var bulan = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Ags', 'Sept', 'Okt', 'Nov', 'Des'];
      var tgl = new Date(date);
      var kosongJam;
      if (tgl.getHours()<10) {
          kosongJam = "0";
      } else {
          kosongJam = "";
      }
      var kosongMenit;
      if (tgl.getMinutes()<10) {
          kosongMenit = "0";
      } else {
          kosongMenit = "";
      }
      var realBulan = bulan[parseInt(tgl.getMonth())];
      
      
      return realBulan;
    },
    TahunOnly(date) {   
      var tgl = new Date(date);
      var realBulan = tgl.getFullYear();
      
      
      return realBulan;
    },
    sParseInt(data) {
      var d;
      if (data != null && data != "") {
        d = parseInt(data);
      } else {
        d = 0;
      }
      return d;
    },
    android(func, params) {
      if (sessionStorage.getItem("browserToken") == null) {
        if (test == false) {
          if (func == "loading") {
            appmyrtrw.loading(params);

          } else if (func == "waCS") {
            appmyrtrw.waCS(params);

          } else if (func == "openlink") {
            appmyrtrw.openlink(params);

          } else if (func == "ownerid") {
            appmyrtrw.ownerid(params);

          } else if (func == "copy") {
            appmyrtrw.copy(params);

          } else if (func == "setTitle") {
            appmyrtrw.setTitle(params);

          } else if (func == "toast") {
            appmyrtrw.toast(params);

          } else if (func == "loadingHide") {
            appmyrtrw.loadingHide();

          } else if (func == "close") {
            appmyrtrw.close();

          } else if (func == "history") {
            appmyrtrw.history();

          } else if (func == "qrcok") {
            appmyrtrw.qrcok(params.qr, params.invoice);

          } else if (func == "email") {
            appmyrtrw.toEmailPage(params);

          } else if (func == "waBantuan") {
            appmyrtrw.waBantuan(params.nama, params.telepon, params.teks);

          } else if (func == "logout") {
            appmyrtrw.logout();
          }
        } else { 
            console.log(params);
        }
      }
    },
    androidGet(func) {
      if (test == false) {
        if (func == "token") {
          return appmyrtrw.getToken();
        } else if (func == "tokenu") {
          if (sessionStorage.getItem("browserToken") != null) {
            //console.log(sessionStorage.getItem("browserToken"));
            return sessionStorage.getItem("browserToken");
          } else {
            return appmyrtrw.getToken();
          }
        } else if (func == "latlng") {
          return appmyrtrw.getLatLng();
        }
      } else {
        if (func == "token") { // owner

          return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJpYXQiOjE2NzE3MTY4NTksImp0aSI6IitzYlBUU0ZaSjgrcTFsQktWMDVXK0hsSkUyaEdjbHRlQldNUWlmSzdMQ0U9IiwiaXNzIjoiaHR0cDpcL1wvMTkyLjE2OC4xMDAuNFwvb2pla09ubHlcLyIsIm5iZiI6MTY3MTcxNjg1OSwiZXhwIjoxNzAzMjc0NDU5LCJkYXRhIjp7InVzZXJJZCI6IjEiLCJ1c2VyTmFtYSI6Ik5pZGhhICYgS2F5bGFfTmV0IiwidXNlckFyZWEiOiItIiwic3ViQWRtaW5JZCI6MCwic3ViQWRtaW5OYW1hIjowLCJ4cGFzIjoiZDY4Mjk4M2E5MzVlNWIxYjk3NjdmNmZiMjJlYWM0MmUifX0.1g0zIgIrmArjrOCZPPOOArco23YnRwP3ve493J7Rg6M9gJvC1A_rN63VNF5vtmfvmW7q_TiFynFFFF1ltS6wmA";
        
        } else if (func == "tokenu") {

          if (test == false) {
            // rilis
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJpYXQiOjE2NDQyODQ1MzAsImp0aSI6InNnc3NtRlB6bWtSRHY2UXY2bXk2cHhrVHdsQmlyUE1hK2p2THJRazNLNE09IiwiaXNzIjoiaHR0cDpcL1wvMTkyLjE2OC4xMDAuNFwvb2pla09ubHlcLyIsIm5iZiI6MTY0NDI4NDUzMCwiZXhwIjoxNjc1ODQyMTMwLCJkYXRhIjp7InVzZXJJZCI6IjEzNTcyIiwidXNlck5hbWEiOiJjb2JhIG5vIHBhc3N3b3JkIn19.QDLoMMHkra1FG1dse7RlM663Zx9jYvR3ZkzoFfA8vp_xFwBUHAGBDbW23_dx6zzSDA3ZEEi8NbMS_hQaCO4Q8g";
          
          } else {

            // dev

            // NON ISOLIR AKUN
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJpYXQiOjE2NzUwMzE3OTIsImp0aSI6IjkzWE9TSXdjXC8xSDhiTHBGTmpMbUtUTGRSYW84bHFBTjNoa1YxUDJNMzhNPSIsImlzcyI6Imh0dHA6XC9cLzE5Mi4xNjguMTAwLjRcL29qZWtPbmx5XC8iLCJuYmYiOjE2NzUwMzE3OTIsImV4cCI6MTcwNjU4OTM5MiwiZGF0YSI6eyJ1c2VySWQiOiIxMzY1NiIsInVzZXJOYW1hIjoiY29iYSBubyBwcm9yYXRhIDIifX0.omKMqDKsAIEIlAwgfj2j9wTI1a71DINJQWA6UoNlGOvQrAp7zA3AiNgpiIczHENeKhibHc5g9ZcUQhwHwQtyVw";

            // isolir
            // return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJpYXQiOjE2NzU2NDU1MzUsImp0aSI6InpxSWNzOTNreTVKdlZZZTJKZEtFTWI0bW9FckNCWEdsUUpsdXNpbmt5ZE09IiwiaXNzIjoiaHR0cDpcL1wvMTkyLjE2OC4xMDAuNFwvb2pla09ubHlcLyIsIm5iZiI6MTY3NTY0NTUzNSwiZXhwIjoxNzA3MjAzMTM1LCJkYXRhIjp7InVzZXJJZCI6IjEzNjU3IiwidXNlck5hbWEiOiJjb2JhIG5vIHByb3JhdGEgMyBmdWxsIn19.hk8sauhHJs-u_Eu5v6Rw_VbcAIsAXKuIE5TU9oHIJVlbGMFuhjk4G0v846xiQq4sfdei3VahiCn9hrjD0kBSjQ";
          
          }

        }
      }
    },
    checkApp() {
      
      if (test == false) {
        if (sessionStorage.getItem("browserToken") == null) {
            try {
            // eslint-disable-next-line no-undef
                if (appmyrtrw) {
                    // eslint-disable-next-line no-undef
                    //appx.printTicket('Hello World');

                    // DIAKSES DARI MY WIFISSSSSSS
                } else {
                  location.href="#/";
                }
            } catch (error) {
                console.log("oops tidak boleh bambang");
                location.href="#/";
            } 
        }
      }

    }
}


// WEBPACK FOOTER //
// ./src/MyGlobal.js